// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Otherwise it's done by "require" which needs eslint-disable-next-line @typescript-eslint/no-var-requires
import aviobookLogo from './aviobook_logo.png';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Otherwise it's done by "require" which needs eslint-disable-next-line @typescript-eslint/no-var-requires
import paperAirplaneSrc from './paper_airplane.png';

export const AviobookLogo = aviobookLogo;
export const PaperAirplane = paperAirplaneSrc;
